import { render, staticRenderFns } from "./payCertCheck.vue?vue&type=template&id=c1cc234c&"
import script from "./payCertCheck.vue?vue&type=script&lang=js&"
export * from "./payCertCheck.vue?vue&type=script&lang=js&"
import style0 from "./payCertCheck.vue?vue&type=style&index=0&id=c1cc234c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports